import { Optional } from '../../Common/interfaces';

const regex = /\/logbook\/(?:([^/?]+)(?:\/([^/?]+))?)?/;

export type ParsedURL = {
    program?: Optional<string>;
    exerciseCode?: Optional<string>;
    showPersonalNotes: boolean;
    showPersonalNoteEditor: boolean;
    personalNoteId?: number;
    showThermometerOverview: boolean;
};
export function parseURL(url: string = location.href): ParsedURL {
    const [_, firstLevelID, secondLevelID] = url.match(regex) ?? [];
    switch (firstLevelID) {
        case 'personal':
            return {
                exerciseCode: null,
                showPersonalNotes: true,
                showPersonalNoteEditor: false,
                personalNoteId: null,
                showThermometerOverview: false,
            };
        case 'thermometeroverview':
            return {
                exerciseCode: null,
                showPersonalNotes: false,
                showPersonalNoteEditor: false,
                personalNoteId: null,
                showThermometerOverview: true,
            };
        case 'editor':
            return {
                exerciseCode: null,
                showPersonalNotes: true,
                showPersonalNoteEditor: true,
                personalNoteId: Number(secondLevelID),
                showThermometerOverview: false,
            };
        default:
            return {
                program: secondLevelID && firstLevelID,
                exerciseCode: secondLevelID ?? firstLevelID,
                showPersonalNotes: false,
                showPersonalNoteEditor: false,
                personalNoteId: null,
                showThermometerOverview: false,
            };
    }
}
